import {
  Component,
  Input,
  signal,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { GetSystemConfigViewModel } from 'edu-application/dist/system-config/get-system-config/get-system-config.veiwmodel';
import { SettingsService } from '../settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';

type IanaTimezone = 'Africa/Cairo' | 'Asia/Riyadh' | 'Asia/Dubai';

interface TimezoneOption {
  value: IanaTimezone;
  label: string;
  offset: string;
  countries: string;
  flag: string;
}
@Component({
  selector: 'edu-timezone-settings',
  standalone: false,
  templateUrl: './timezone-settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './timezone-settings.component.scss',
})
export class TimezoneSettingsComponent {
  @Input() orgId!: string;
  @Input() systemConfig: GetSystemConfigViewModel | null = null;
  selected = signal<IanaTimezone>('Africa/Cairo');
  isSaving = signal(false);

  timezones: TimezoneOption[] = [
    {
      value: 'Africa/Cairo',
      label: 'Egypt Time',
      offset: 'UTC+2 / UTC+3 (DST)',
      countries: 'Egypt',
      flag: '🇪🇬',
    },
    {
      value: 'Asia/Riyadh',
      label: 'Arabia Standard Time',
      offset: 'UTC+3',
      countries: 'KSA · Kuwait · Bahrain · Qatar',
      flag: '🇸🇦',
    },
    {
      value: 'Asia/Dubai',
      label: 'Gulf Standard Time',
      offset: 'UTC+4',
      countries: 'UAE · Oman',
      flag: '🇦🇪',
    },
  ];

  constructor(
    private settingsService: SettingsService,
    private snackBar: MatSnackBar,
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['systemConfig'] && this.systemConfig?.timezone) {
      this.selected.set(this.systemConfig.timezone as IanaTimezone);
    }
  }

  select(value: IanaTimezone): void {
    this.selected.set(value);
  }

  save(): void {
    this.isSaving.set(true);
    this.settingsService
      .upsertSystemConfig(this.orgId, { timezone: this.selected() })
      .subscribe({
        next: () => {
          this.snackBar.open('✅ Timezone saved successfully', 'Dismiss', {
            duration: 3000,
          });
          this.isSaving.set(false);
        },
        error: () => {
          this.snackBar.open('❌ Failed to save timezone', 'Dismiss', {
            duration: 3000,
          });
          this.isSaving.set(false);
        },
      });
  }
}
